<template>
    <v-navigation-drawer
      :value="drawer"
      @input="handleInput"
      :width="`${$theme.layout.sidebarWidth}px`"
      :right="$theme.layout.sidebarPosition === 'right'"
      app
      :permanent="!isMobile"
      :absolute="isMobile"
      :temporary="isMobile"
      class="transition-all"
    >
      <div class="sidebar-top">
        <div class="pa-4 d-flex flex-column align-center">
          <v-img
            :src="$theme.assets.logoCurrent"
            :height="logoHeight"
            contain
            class="mb-4 cursor-pointer"
            @click="toggleDrawer"
          ></v-img>
        </div>
        <div>
          <slot name="top" :drawer="drawer">
            <!-- Additional top content can be injected here -->
          </slot>
        </div>
      </div>
      
      <div class="sidebar-conversations">
        <slot name="conversations">
          <!-- Conversations content can be injected here -->
        </slot>
      </div>
    </v-navigation-drawer>
</template>


<script>
export default {
  name: 'SidebarNav',
  props: {
    drawer: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    logoHeight() {
      // Smaller logo on mobile, normal size on desktop
      return this.$theme.layout.sidebarLogoHeight;
    }
  },
  methods: {
    toggleDrawer() {
      this.$emit('drawer-toggle');
    },
    handleInput(value) {
      this.$emit('drawer-input', value);
    }
  }
}
</script>


<style scoped>
.v-list-item { border-radius: 6px; }
.sidebar {
  background: #F0F0F0;
  display: flex;
  flex-direction: column;
}

.sidebar-top {
  flex-shrink: 0;
}

.sidebar-conversations {
  flex: 1;
  overflow-y: auto;
}

.cursor-pointer {
  cursor: pointer;
}
</style>